import React from 'react';
import AppButton from './AppButton';
import cx from './cx';

const buildPageNumbers = (page, pages, maxVisible = 7) => {
  const pageNumbers = [];
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(pages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }
  for (let i = start; i <= end; i += 1) {
    pageNumbers.push(i);
  }
  return pageNumbers;
};

const AppPagination = ({
  variant = 'numbered',
  pagination,
  page,
  pages,
  total,
  onPageChange,
  search = '',
  totalLabel,
  className = '',
}) => {
  const currentPage = pagination?.page ?? page ?? 1;
  const pageCount = pagination?.pages ?? pages ?? 0;
  const totalCount = pagination?.total ?? total ?? 0;
  const countLabel = totalLabel || `${totalCount} résultat${totalCount > 1 ? 's' : ''}`;

  if (variant === 'simple') {
    if (totalCount <= 0) return null;
    return (
      <div className={cx('d-flex justify-content-between align-items-center', className)}>
        <span className="text-sm text-secondary-light">{countLabel}</span>
        <div className="d-flex gap-2">
          <AppButton
            size="sm"
            variant="outline-secondary"
            disabled={currentPage <= 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            Précédent
          </AppButton>
          <span className="align-self-center text-sm">Page {currentPage} / {pageCount || 1}</span>
          <AppButton
            size="sm"
            variant="outline-secondary"
            disabled={currentPage >= (pageCount || 1)}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Suivant
          </AppButton>
        </div>
      </div>
    );
  }

  if (pageCount <= 1) return null;

  const pageNumbers = buildPageNumbers(currentPage, pageCount);

  return (
    <nav aria-label="Pagination" className={cx('mt-4', className)}>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <small className="text-secondary-light">{countLabel}</small>
        <ul className="pagination mb-0">
          <li className={cx('page-item', currentPage <= 1 && 'disabled')}>
            <button
              type="button"
              className="page-link"
              disabled={currentPage <= 1}
              onClick={() => onPageChange(currentPage - 1, search)}
            >
              ‹
            </button>
          </li>
          {pageNumbers.map((n) => (
            <li key={n} className={cx('page-item', n === currentPage && 'active')}>
              <button type="button" className="page-link" onClick={() => onPageChange(n, search)}>
                {n}
              </button>
            </li>
          ))}
          <li className={cx('page-item', currentPage >= pageCount && 'disabled')}>
            <button
              type="button"
              className="page-link"
              disabled={currentPage >= pageCount}
              onClick={() => onPageChange(currentPage + 1, search)}
            >
              ›
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AppPagination;
